import { render } from "./salesReportTable.vue?vue&type=template&id=6faaae1e&scoped=true"
import script from "./salesReportTable.vue?vue&type=script&lang=js"
export * from "./salesReportTable.vue?vue&type=script&lang=js"

import "./salesReportTable.vue?vue&type=style&index=0&id=6faaae1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faaae1e"]])

export default __exports__